import React from "react";
import { motion } from "framer-motion";
import {
  Search,
  Network,
  EyeOff,
  FileText,
  Clock,
  CircleDollarSign,
} from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import SectionBadge from "@/components/SectionBadge";

const icons = [Search, Network, EyeOff, FileText, Clock, CircleDollarSign];

const ProblemsSection = () => {
  const { t } = useLang();
  return (
    <section
      id="problemas"
      data-testid="problems-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
            <SectionBadge>{t.problems.eyebrow}</SectionBadge>
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6 }}
              className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.08] tracking-tight text-white text-balance"
            >
              {t.problems.titleStart}{" "}
              <span className="text-[#1dc7e9]">{t.problems.titleAccent}</span>
            </motion.h2>
            <p className="mt-5 text-[#b8c0cc] leading-relaxed">
              {t.problems.description}
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {t.problems.items.map((item, i) => {
              const Icon = icons[i % icons.length];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}
                  className="card-glow rounded-2xl bg-white/[0.02] border border-[#1dc7e9]/15 p-5 hover:border-[#1dc7e9]/45 hover:bg-white/[0.035] hover:-translate-y-0.5 transition-all duration-300"
                  data-testid={`problem-card-${i}`}
                >
                  <div className="flex items-start gap-3">
                    <div className="shrink-0 w-9 h-9 rounded-lg bg-[#1dc7e9]/10 border border-[#1dc7e9]/25 flex items-center justify-center text-[#1dc7e9]">
                      <Icon size={16} strokeWidth={1.8} />
                    </div>
                    <div>
                      <h3 className="text-white font-semibold text-[15px] tracking-tight">
                        {item.title}
                      </h3>
                      <p className="text-[#b8c0cc] text-[13px] mt-1 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemsSection;
